import Component from 'vue-class-component';
import ShadowDom from '@/common/ts/shadow-dom/ShadowDom';
import Vue from 'vue';

export const VIDEO_ADD_EVENT = 'brandhub-video-added';

@Component
export default class VideoPauseHandler extends Vue {
  allVideosOnPage: HTMLVideoElement[] = [];
  pausedVideos: HTMLVideoElement[] = [];
  private static instance: VideoPauseHandler;

  static getInstance (): VideoPauseHandler {
    if (!VideoPauseHandler.instance) {
      VideoPauseHandler.instance = new VideoPauseHandler();
    }
    return VideoPauseHandler.instance;
  }

  addNewVideo (videoPlayer: HTMLVideoElement) {
    this.allVideosOnPage.push(videoPlayer);

    this.removeVideosNotInDocument();
  }

  removeVideosNotInDocument () {
    this.allVideosOnPage.forEach((video) => {
      if (!ShadowDom.isInDocument(video)) {
        const index = this.allVideosOnPage.indexOf(video, 0);
        if (index > -1) {
          this.allVideosOnPage.splice(index, 1);
        }
      }
    });
  }

  pauseAllVideos () {
    this.removeVideosNotInDocument();
    this.allVideosOnPage.forEach((video) => {
      if (!video.paused) {
        this.pausedVideos.push(video);
        video.pause();
      }
    });
  }

  playPausedVideos () {
    this.pausedVideos.forEach((video) => {
      video.play();
    });
    this.pausedVideos = [];
  }
}
